import type { RouteRecordNameGeneric } from "vue-router";
import type { ProductMode } from "@shared/config/types";
import { RouteName } from "@shared/types/routes";

export const PLAN_PATH = "/plan-route";
export const TRUCK_PLAN_PATH = "/plan-truck-route";

export const isPlanRouteName = (name: RouteRecordNameGeneric): boolean =>
  name === RouteName.PLAN_ROUTE || name === RouteName.PLAN_TRUCK_ROUTE;

export const getProductModeFromPath = (
  path: string,
): ProductMode | undefined => {
  if (path.startsWith(TRUCK_PLAN_PATH)) return "commercial";
  if (path.startsWith(PLAN_PATH)) return "personal";
};
